import { render } from "./cHeader.vue?vue&type=template&id=80041b32&bindings={\"title\":\"props\",\"leftText\":\"props\",\"rightText\":\"props\",\"leftArrow\":\"props\",\"border\":\"props\",\"onClickLeft\":\"setup\",\"onClickRight\":\"setup\",\"pops\":\"setup\"}"
import script from "./cHeader.vue?vue&type=script&lang=js"
export * from "./cHeader.vue?vue&type=script&lang=js"

import "./cHeader.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script